<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="fileinput-container"
  [ngClass]="{
    'file-drag-active': fileDragOver,
    'file-drag-inactive': !fileDragOver,
    'fileinput-disabled': disabled,
  }"
  (dragover)="fileDragStart($event)"
  (drop)="fileDragDrop($event)">
  <div class="file-drag-overlay" (dragleave)="fileDragEnd($event)">
    <div class="inner"><span>&nbsp;</span></div>
  </div>
  <div
    class="fileinput"
    [ngClass]="input.uploadFile.name ? 'fileinput-exists' : 'fileinput-new'">
    @if (isTruncated) {
      <div class="form-control">
        <span
          class="fileinput-filename"
          (DOMSubtreeModified)="checkTrucation($event)"
          id="trucated"
          [ngClass]="{ 'placeholder-text': !input.uploadFile.name }"
          [xdaTranslate]="input.uploadFile.name || 'SDE_DROP_FILE_HERE1'"
          placement="top"
          [autoClose]="true"
          triggers="click:blur"
          tooltipClass="filename-tooltip"
          [ngbTooltip]="input.uploadFile.name"></span>
      </div>
    }
    @if (!isTruncated) {
      <div class="form-control" (click)="uploadFileInput.click()">
        <span
          class="fileinput-filename"
          (DOMSubtreeModified)="checkTrucation($event)"
          id="not-trucated"
          [ngClass]="{ 'placeholder-text': !input.uploadFile.name }"
          [xdaTranslate]="input.uploadFile.name || 'SDE_DROP_FILE_HERE1'">
        </span>
      </div>
    }
    <div class="fileinput-input">
      <div
        class="xrx-btn btn-primary btn-short fileinput-btn-file"
        [ngClass]="disabled ? 'disabled' : ''">
        <span class="fileinput-new fileinput-btn-file-label" xdaTranslate
          >SDE_BROWSE</span
        >
        <span
          class="fileinput-new fileinput-btn-file-glyph xgl-file_add"></span>
        <span class="xgl-change fileinput-exists fileinput-btn-change"></span>
        <input type="hidden" value="" name="..." />
        <input
          #uploadFileInput
          ngModel
          type="file"
          [id]="id"
          [name]="name"
          [disabled]="disabled"
          [accept]="fileTypesAccepted"
          [multiple]="multiple"
          (change)="inputChange($event.target.files)"
          onclick="this.value = ''"
          tabindex="-1" />
      </div>
    </div>
    <div class="fileinput-btn-divider fileinput-exists">&nbsp;</div>
    <div class="fileinput-delete">
      <a
        href="#"
        (click)="
          input.uploadFile = {};
          uploadFileInput.value = '';
          inputChange(uploadFileInput.files)
        "
        class="xrx-btn btn-primary btn-short fileinput-exists xgl-trash fileinput-btn-delete"
        aria-label="Remove file"></a>
    </div>
  </div>
  @if (
    !input.uploadFile.name && this.ngControl.control?.touched && this.required
  ) {
    <div class="fileinput-error">
      <span class="text-danger" [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
    </div>
  }
  @if (this.fileFormatNotSupported) {
    <div class="fileinput-error">
      <span class="text-danger" [xdaTranslate]="'SDE_FILE_FORMAT_NOT'"></span>
    </div>
  }
</div>
